module.exports = __webpack_public_path__ + "static/img/feature01.46a7356a.png";